<div class="max-w-[min(90%,1000px)] mx-auto">
  <!-- AI Answer Section -->
  @if (temporaryAnswer.length || (finalAIResponse.length && searchType.includes('ai') && !temporaryAnswer.length && finalAIResponse !== 'null')) {
    <div class="ai-answer-section">
      <div class="ai-content">
        <markdown [data]="temporaryAnswer || finalAIResponse"></markdown>
      </div>
    </div>
  }

  @if (loading) {
    <div class="flex flex-col gap-4 mb-4">
      <ui-skeleton></ui-skeleton>
      <ui-skeleton></ui-skeleton>
      <ui-skeleton></ui-skeleton>
      <ui-skeleton></ui-skeleton>
      <ui-skeleton></ui-skeleton>
    </div>
  }

  <!-- Results List -->
  @if (groupedEditions.length > 0) {
    <div class="results-list">
      @for (group of groupedEditions; track group) {
        <div class="result-card">
          <!-- Card Body: Content Chunks -->
          <div class="card-body">
            @for (edition of group.editions; track edition; let first = $first) {
              @if (!first) {
                <div class="chunk-divider my-3" style="border-top: 1px dashed var(--skz-border-color-main); opacity: 0.6;"></div>
              }
              <div class="chunk-item">
                @if (edition.type == 'html') {
                  <div [innerHTML]="edition.sanitizedHTML || edition.content" class="text-content"></div>
                }
                @if (edition.type == 'text') {
                  <div class="text-content">{{ edition.content }}</div>
                }
                @if (edition.type == 'code') {
                  <div class="code-content">
                    <pre class="language-{{ edition.codeLanguage }}" [innerHTML]="edition.content"></pre>
                  </div>
                }
                @if (edition.type == 'video') {
                  <div class="media-content">
                    <div class="video-wrapper">
                      @if (!edition.waitngForDownloadUrl) {
                        <video #videoPlayer [id]="edition._id" controls height="100%" width="100%" controlsList="nodownload">
                          <source [src]="edition.content" type="video/mp4" />
                          Your browser does not support HTML5 video.
                        </video>
                      }
                    </div>
                  </div>
                }
                @if (edition.type == 'image') {
                  <div class="media-content">
                    <img [src]="edition.content" />
                  </div>
                }
                @if (edition.type == 'file') {
                  <div class="file-content">
                    <a class="file-download" [attr.href]="edition.content">
                      <div class="file-container">
                        <span class="material-icons">download_for_offline</span>
                        <span>{{ edition.filename }}</span>
                      </div>
                    </a>
                  </div>
                }
                @if (edition.tags?.length > 0) {
                  <div class="transcript-card" [class.is-expanded]="isTagsExpanded(edition._id)">
                    <div class="transcript-preview-area">
                      <div
                        class="transcript-preview-container custom-scrollbar"
                        [class.expandable]="edition.tags.length > 6 && !isTagsExpanded(edition._id)"
                        [class.expanded]="edition.tags.length > 6 && isTagsExpanded(edition._id)"
                      >
                        <mat-chip-set class="tags-chip-set">
                          @for (tag of edition.tags; track tag) {
                            <mat-chip [class.clickable-tag]="!!tag.timestamp" (click)="tag.timestamp ? playVideoAt(edition, tag.timestamp) : null">
                              {{ tag.content }}
                              @if (tag.timestamp) {
                                <span class="timestamp-label">({{ tag.timestamp }})</span>
                              }
                            </mat-chip>
                          }
                        </mat-chip-set>
                      </div>
                      <!-- Expansion Overlay -->
                      @if (edition.tags.length > 6) {
                        <div class="expansion-overlay">
                          <div class="show-more-pill" (click)="$event.stopPropagation(); toggleTags(edition._id)">
                            <span>{{ (isTagsExpanded(edition._id) ? 'Global.ShowLess' : 'Global.ShowMore') | translate }}</span>
                            <mat-icon class="show-more-icon" [class.rotated]="isTagsExpanded(edition._id)">expand_more</mat-icon>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Card Footer: Actions -->
          <div class="card-footer">
            <div class="footer-left">
              <span class="type-badge" [ngClass]="group.type">
                {{ 'SearchResult.Badge.' + group.type | translate }}
              </span>
              <div class="primary-action">
                @if (group.type == 'course') {
                  <div>
                    <a [href]="group.routerLink" class="action-link">
                      {{ 'Search.GoToLecture' | translate }}
                      <mat-icon>arrow_forward</mat-icon>
                    </a>
                  </div>
                }

                @if (group.type == 'note') {
                  <div>
                    <a [href]="group.routerLink" class="action-link">
                      {{ 'Search.GoToNote' | translate }}
                      <mat-icon>arrow_forward</mat-icon>
                    </a>
                  </div>
                }
              </div>
            </div>
            <button mat-icon-button btnType="action-icon" (click)="visulizeContent(group.contentRef?.contentId!)" [matTooltip]="'Global.Preview' | translate">
              <mat-icon>expand_content</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  } @else {
    @if (!loading) {
      <div class="no-result-found">
        <div class="empty-state">
          <mat-icon>search_off</mat-icon>
          <p>{{ 'Search.NoResultFound' | translate }}</p>
        </div>
      </div>
    }
  }
</div>
